import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/login/Login';
import Registration from './components/registration/Registration';
import ResetPassword from './components/reset-password/ResetPassword';
import ForgotPassword from './components/forget-password/ForgetPassword';
import { Provider } from 'react-redux';
import store from './store/store';
import { ToastContainer } from 'react-toastify';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import Dashboard from './pages/Dashboard';
import Emailverified from './components/email-verified/Emailverified';
import Changepassword from './pages/changepassword';
import Myprofile from './pages/myprofile';
import Membersall from './pages/membersall';
import Linkedmembersall from './pages/linkedmembersall';
import Membershiptypes from './pages/membershiptypes';
import Membershippayments from './pages/membershippayments';
import Membershippaymentsbydate from './pages/membershippaymentsbydate';
import Membershippaymentsbyid from './pages/membershippaymentsbyid';
import EventAll from './pages/eventall';
import Events from './pages/events';
import EventRegistrationPage from './pages/eventregistration';
import Eventregistrationall from './pages/eventregistrationall';
import Vieweventsregistration from './pages/vieweventsregistration';
import PaymentSuccess from './pages/PaymentSuccess';
import ThankYou from './pages/Thankyou';
import RenewMembership from './pages/renewmembership';
import Myeventregistration from './pages/myeventregistration';
import PaymentPage from './pages/paymentpage';
import Paypaltransactionsbydate from './pages/paypaltransactionsbydate';
import PaymentResultPage from './pages/paymentresult';
import RenewPaymentPage from './pages/renewpaymentpage';
import RenewMembershipAndPayment from './pages/renewmembershipandpayment';
import NewRegistration from './components/registration/Newregistration';

function App() {
  return (
    <Provider store={store}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Router>
        <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} /> 
        <Route path="/forgot-password" element={<ForgotPassword />} />      
        <Route path="/emailverified" element={<Emailverified />} />    
        <Route path="/resetpassword" element={<ResetPassword />} />    
        <Route path="/eventregistration" element={<EventRegistrationPage />} />   
        <Route path="/paymentsuccess" element={<PaymentSuccess />} />   
        <Route path="/thank-you" element={<ThankYou />} />   
        <Route path="/payment" element={<PaymentPage />} />   
        <Route path="/dashboard" element={<PrivateRoute><Dashboard/></PrivateRoute>} />
        <Route path="/changepassword" element={<PrivateRoute><Changepassword/></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Myprofile/></PrivateRoute>} />
        <Route path="/members" element={<PrivateRoute><Membersall/></PrivateRoute>} />
        <Route path="/linkedmembers" element={<PrivateRoute><Linkedmembersall/></PrivateRoute>} />
        <Route path="/membershiptypes" element={<PrivateRoute><Membershiptypes/></PrivateRoute>} />
        <Route path="/membershippayments" element={<PrivateRoute><Membershippayments/></PrivateRoute>} />
        <Route path="/membershippaymentsbydate" element={<PrivateRoute><Membershippaymentsbydate/></PrivateRoute>} />
        <Route path="/mypayments" element={<PrivateRoute><Membershippaymentsbyid/></PrivateRoute>} />
        <Route path="/eventsall" element={<PrivateRoute><EventAll/></PrivateRoute>} />
        <Route path="/events" element={<PrivateRoute><Events/></PrivateRoute>} />
        <Route path="/eventregistrations" element={<PrivateRoute><Eventregistrationall/></PrivateRoute>} />
        <Route path="/viewregistration" element={<PrivateRoute><Vieweventsregistration/></PrivateRoute>} />
        <Route path="/renewmembership" element={<PrivateRoute><RenewMembership/></PrivateRoute>} />
        <Route path="/myeventregistration" element={<PrivateRoute><Myeventregistration/></PrivateRoute>} />
  
        <Route path="/paypaltransactions" element={<PrivateRoute><Paypaltransactionsbydate/></PrivateRoute>} />
        <Route path="/paymentresult" element={<PrivateRoute><PaymentResultPage/></PrivateRoute>} />
        <Route path="/renew-payment" element={<PrivateRoute><RenewPaymentPage/></PrivateRoute>} />
        <Route path="/renewmembershippaypal" element={<PrivateRoute><RenewMembershipAndPayment/></PrivateRoute>} />
      
     
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
